import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLegacyRedirectTarget } from '../../hooks/useLegacyRedirectTarget';

export const HeadcountLegacyRedirect = (): JSX.Element => {
  const target = useLegacyRedirectTarget();
  return <Navigate to={target} replace />;
};
